import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class Phone extends Vue {
  phoneNumberDatas: any = {}
  @Getter('locale', { namespace: 'user' }) locale

  get phoneNumberIsValid() {
    return this.phoneNumberDatas ? this.phoneNumberDatas.isValid : false
  }

  get defaultPhoneCountry() {
    return this.locale ? this.locale.toUpperCase() : 'FR'
  }

  updatePhoneNumberDatas(datas) {
    this.phoneNumberDatas = datas
  }


}
